import { ApplicationContext } from '@wix/editor-platform-contexts';
import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

// export type IBaseSDKShape = new (
//   overrideApplicationContext?: Promise<ApplicationContext<any>>,
// ) => any;

export enum BaseSDKErrorCode {
  ManifestContextIdRequired = 'ManifestContextIdRequired',
}

class BaseSDKError extends BaseError<BaseSDKErrorCode> {
  constructor(message: string, code: BaseSDKErrorCode) {
    super(message, code, 'Base SDK Error');
  }
}

const createBaseSDKError = createErrorBuilder<BaseSDKErrorCode, BaseSDKError>(
  BaseSDKError,
);

export class BaseSDKShape {
  constructor(
    protected overriddenApplicationContext: Promise<ApplicationContext> | null = null,
  ) {}

  protected getApplicationContext() {
    return this.overriddenApplicationContext
      ? this.overriddenApplicationContext
      : ApplicationContext.getInstance();
  }

  protected async getAppDefinitionId() {
    return (await this.getApplicationContext()).getAppDefinitionId();
  }

  protected async getManifestContextId() {
    return (await this.getApplicationContext()).getManifestContextId();
  }

  protected async getRequiredManifestContextId() {
    const manifestContextId = await this.getManifestContextId();
    if (!manifestContextId) {
      throw createBaseSDKError(BaseSDKErrorCode.ManifestContextIdRequired);
    }

    return manifestContextId;
  }

  protected async getEnvironmentContext() {
    return (await this.getApplicationContext()).getEnvironmentContext();
  }

  protected async getPlatformPrivateAPI() {
    return (await this.getApplicationContext()).getPrivateAPI();
  }

  // NOTE: don't remove this for now
  // protected dep<TDep extends IBaseSDKShape>(Factory: TDep) {
  //   let instance: InstanceType<TDep>;
  //
  //   return () => {
  //     if (!instance) {
  //       instance = new Factory(this.getApplicationContext());
  //     }
  //
  //     return instance;
  //   };
  // }
}
